<!--suppress XmlUnboundNsPrefix -->
<div class="table-controls">
  <p-dropdown #tableTypesDropdown [options]="tableTypes" [(ngModel)]="tableType"></p-dropdown>&nbsp;&nbsp;
  <p-dropdown #planetsDropdown [options]="planetChoices" [(ngModel)]="planetChoice" [disabled]="!planetChoiceEnabled"></p-dropdown>
</div>
<div #wrapper class="wrapper" (window:resize)="onResize()">
  <div #tableContainer class="table-container" [innerHtml]='tableHtml'>&nbsp;</div>
</div>
